import Link from 'next/link';

import { SFCampaignPromotionItemViewModel } from '@api/index';
import { daysBetween } from '@utils/dateUtil';
import { cloudineryImage } from '@components/views/hotel/detail/utils/features';

import {
  BottomRightImageWrapper,
  Card,
  CardContent,
  CardImageInnerWrapper,
  CardImageWrapper,
  CardLink,
  CardMedia,
  CardTitle,
  ExpirationDateWrapper,
  StyledTypography,
} from './styled';

export interface ICampainCard extends SFCampaignPromotionItemViewModel {
  hasDescription?: boolean;
}

const CampainCard = ({
  title,
  image = { url: '/static/images/placeholder-image.webp' },
  href,
  description,
  hasDescription = false,
  lastDate,
  ticketImage,
}: ICampainCard) => {
  return (
    <Link prefetch={false} href={href || ''} passHref legacyBehavior>
      <CardLink>
        <Card>
          <CardImageWrapper>
            <CardImageInnerWrapper>
              <CardMedia
                className='campainCard__image'
                backgroundImageUrl={cloudineryImage(
                  image?.url || '/static/images/placeholder-image.webp',
                  '450',
                  '450'
                )}
              />
            </CardImageInnerWrapper>
            {lastDate && daysBetween(new Date(), new Date(lastDate)) >= 0 && (
              <ExpirationDateWrapper>
                <span>
                  SON
                  {` ${
                    daysBetween(new Date(), new Date(lastDate)) === 0
                      ? ''
                      : daysBetween(new Date(), new Date(lastDate))
                  } `}
                  <strong>GÜN</strong>
                </span>
              </ExpirationDateWrapper>
            )}
            {ticketImage?.url && (
              <BottomRightImageWrapper backgroundImageUrl={ticketImage?.url} />
            )}
          </CardImageWrapper>
          <CardContent>
            <CardTitle className='campaignCard__title'>{title}</CardTitle>
            {hasDescription && (
              <StyledTypography>{description}</StyledTypography>
            )}
          </CardContent>
        </Card>
      </CardLink>
    </Link>
  );
};
export default CampainCard;
